class Utils {
    constructor() {
        this.gradients = {};
        this.set_gradients();
    }

    copyToClip(str) {
        function listener(e) {
          e.clipboardData.setData("text/html", str);
          e.clipboardData.setData("text/plain", str);
          e.preventDefault();
        }
        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
      };
      
      CopyToClipboard(element) {
          // array off all block level elements
          var block_level_elements = ['P','H1', 'H2', 'H3', 'H4', 'H5', 'H6','OL', 'UL','DIV','FORM','HR','TABLE'];	
      
          //create new Element so we can vhange elments like we need
          var newelment = document.createElement("div");
      
          //copy target Element to the new Element
          newelment.innerHTML = element.innerHTML;
      
          //hide new Element to body
          newelment.classList.add('toCopy')
          newelment.style.opacity  = 0;
          
          // add new Element to body
          document.body.appendChild(newelment);
      
          //get all element childs
          var descendents = newelment.getElementsByTagName('*');
      
          //loop in childs
          for (var i = 0; i < descendents.length; ++i) {
              //get defult Style
              var style = window.getComputedStyle(descendents[i]);
              var dis = style.getPropertyValue('display');
              //get defult tag name
              var tagname = descendents[i].tagName;
              
              //---------------------------
              //this part is little tricky
              //---------------------------
              //true : Element is a block level elements and css display is inline
              if(dis.includes("inline") && block_level_elements.includes(tagname)){
                  //get all Element style include default style
                  var defultcss = document.defaultView.getComputedStyle(descendents[i], "").cssText;
                  //chang Element tag from block level elements to inline level elements (span)
                  descendents[i].outerHTML = descendents[i].outerHTML.replace(new RegExp(tagname, "ig"),"span");			//todo: need to change RegExp to tag name only not inner text 
                  //add all Element style include default style to new tag
                  descendents[i].style.cssText = defultcss;
              }
          }
          //-----------------copy new Element--------------
          var doc = document;
          var range, selection;
          
          if (doc.body.createTextRange)
          {
              range = doc.body.createTextRange();
              range.moveToElementText(newelment);
              range.select();
          } 
          
          else if (window.getSelection)
          {
              selection = window.getSelection();        
              range = doc.createRange();
              range.selectNodeContents(newelment);
              selection.removeAllRanges();
              selection.addRange(range);
           }
          document.execCommand('copy');
          window.getSelection().removeAllRanges();
          
          // remove new Element from document
          document.body.removeChild(newelment); 
          
    }

    deleteFeedback (id, brand) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/delete_file',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify({
                    'id': id,
                    "brand": brand
                })
            }
        )
        .then((response) => { 
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            console.warn(err)
            return {}
        });
    }

    set_gradients() {
        var c = document.getElementById("grd");
        var ctx = c.getContext("2d");

        // Create gradient
        var grd1 = ctx.createLinearGradient(150, 600, 0, 0);
        grd1.addColorStop(0, "rgba(212,173,78,0.8)");
        grd1.addColorStop(0.56, "rgba(194,80,50,1)");
        this.gradients.red = grd1;

        var grd2 = ctx.createLinearGradient(0, 0, 150, 600);
        grd2.addColorStop(0, "rgba(99,244,251,0.8)");
        grd2.addColorStop(0.56, "rgba(48,110,247,0.8)");
        this.gradients.blue = grd2

        var grd3 = ctx.createLinearGradient(0, 0, 150, 600);
        grd3.addColorStop(0, "rgba(114,249,255,1)");
        grd3.addColorStop(1, "rgba(0,156,163,1)");
        this.gradients.turquoise = grd3

        var grd4 = ctx.createLinearGradient(0, 0, 150, 600);
        grd4.addColorStop(0, "rgba(255,186,135,1)");
        grd4.addColorStop(1, "rgba(255,165,0,1)");
        this.gradients.orange = grd4

        var grd5 = ctx.createLinearGradient(0, 0, 150, 600);
        grd5.addColorStop(0, "rgba(200,200,200,1)");
        grd5.addColorStop(1, "rgb(162,162,162)");
        this.gradients.grey = grd5
    }

    mobileCheck() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    getLanguage(dict) {
        if (typeof(dict) === "string" || dict === undefined) {
            return dict;
        }
        const lgs = navigator.languages.map(
            x => x.substring(0, 2)
        )

        for (const lg of lgs) {
            if (dict.hasOwnProperty(lg)) {
                return dict[lg]
            }
        }
        return dict[Object.keys(dict)[0]]
    }

    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[#&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    }

    async fetchUserData() {
        console.log("🔴", this.getUrlVars()['access_token'] || localStorage.getItem('token'))
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_brands',
            {
                method: "GET",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') }
            }
        )
        .then((response) => {
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            console.warn(err)
            return {}
        });
    }

    fetchLastFeedbacks(filters) {

        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_last_feedbacks',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
        .then((response) => {
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            return {}
        });
    }

    fetchExportData (filters, configs={}) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/export',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify({
                    "filters": filters,
                    "configs": configs
                })
            }
        )
        .then((response) => {
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            console.warn(err)
            return {}
        });
    }

    deleteFeedback (id, brand) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/delete_file',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify({
                    'id': id,
                    "brand": brand
                })
            }
        )
        .then((response) => { 
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            console.warn(err)
            return {}
        });
    }

    fetchSteps(filters) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_topics',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        ).then(
            response => {
                if (!response.ok) {
                    return []
                }
                return response.json()
            }
        )
    }

    fetchNerCloud(filters, loadingCallback) {
        loadingCallback = loadingCallback || (flag => {});
        loadingCallback(true)
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_name_entities_cloud',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
        .then((response) => {
            loadingCallback(true)
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            loadingCallback(false)
            console.warn(err)
            return {}
        });
    }

    fetchUpdateState(filters) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/change_state',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
        .then((response) => {
            if (!response.ok) {
                response.text().then(console.error)
                return {}
            }
            return response.json()
        })
    }

    fetchNameEntitiesCloud(filters) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_name_entities_cloud',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
            .then((response) => {
                if (!response.ok) {
                    return {}
                }
                return response.json()
            })
            .catch((err) => {
                return {}
            });
    }

    fetchTopicCloud(filters) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_topic_cloud',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
        .then((response) => {
            if (!response.ok) {
                response.text().then(console.log)
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            return {}
        });
    }

    fetchComments({feedback_id, brand}) {

        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_comments',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify({
                    feedback_id: feedback_id,
                    brand: brand
                })
            }
        )
        .then((response) => {
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            return {}
        });
    }



    sendComments ({feedback_id, brand, text}) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/send_comments',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify({
                    'feedback_id': feedback_id,
                    "brand": brand,
                    "text": text
                })
            }
        )
        .then((response) => { 
            if (!response.ok) {
                return {}
            }
            return response.json()
        })
        .catch((err) => {
            console.warn(err)
            return {}
        });
    }

    fetchAudioPresignedUrl(feedback_id, brand) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_audio_presigned_url?id=' + feedback_id.replace(':', '-') + '&brand=' + brand,
            {
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                method: 'GET'
            }
        ).then(
            response => {
                if (!response.ok) {
                    return new Promise(res => res({}))
                }
                return response.json()
            }
        )
    }

    fetchSettings(username, brand) {
        const myHeaders = new Headers();
        myHeaders.append("cache-control", "no-cache");
        myHeaders.append("pragma", "no-cache");
        let bucket = 'front-end-zevoice'
        if (process.env.REACT_APP_STAGE == "Dev") {
            bucket = 'front-end-zevoice-dev'
        }
        return fetch(
            'https://' + bucket + '.s3.eu-west-2.amazonaws.com/utils/dashboard_settings/' + brand + '/' + username + '.json',
            {
                method: 'GET',
                cache: "no-store"
            }
        ).then(
            resp => {
                if (!resp.ok) {
                    return fetch(
                        'https://' + bucket + '.s3.eu-west-2.amazonaws.com/utils/dashboard_settings/' + brand + '/default.json',
                        {
                            method: 'GET',
                            cache: "no-store"
                        }
                    ).then(resp => {
                        if (resp.ok) {
                            return resp.json()
                        }
                    })
                }
                return resp.json()
            }
        )
    }

    fetchPocTree(tree, brand) {

        const myHeaders = new Headers();
        myHeaders.append("cache-control", "no-cache");
        myHeaders.append("pragma", "no-cache");
        let bucket = 'front-end-zevoice'
        if (process.env.REACT_APP_STAGE == "Dev") {
            bucket = 'front-end-zevoice-dev'
        }
        return fetch(
            'https://' + bucket + '.s3.eu-west-2.amazonaws.com/utils/dashboard_settings/' + brand + '.json',
            {
                method: 'GET',
                cache: "no-store"
            }
        ).then(
            resp => resp.json()
        ).then(
            resp => {
                const pocTree = resp[tree];
                const convertTree = (children, output_parent, output_head) => {
                    for (const i in children) {
                        const child = children[i];
                        // Check if instan
                        const newValue = output_parent['value'] instanceof Array ? [...output_parent['value']] : output_parent['value'].split(" >> ");
                        if (child.hasOwnProperty('id')) {
                            newValue.push(child['id'])
                        } else {
                            newValue.push("[DELETE]" +child['name'])
                        }
                        const value = newValue.join(' >> ');
                        output_head.push({
                            'title': child['name'],
                            'value': value,
                            'key': value
                        })
                        if (child.hasOwnProperty('children')) {
                            output_head[i]['children'] = convertTree(child['children'], output_head[i], [])
                        }
                    }
                    return output_head
                }

                return convertTree(
                    pocTree,
                    {'value': []},
                    []
                )
            }
        )
    }

    aggregateFeedbackBySteps(feedbacks, steps) {
        if (!feedbacks) {
            return []
        }
        return steps.map(x => {
                return {
                    'step_name': x,
                    'positive_comments_count': feedbacks.reduce((acc, v) => {
                        return acc + (v.hasOwnProperty(x) ? v[x]['positive'] : 0)
                    }, 0),
                    'negative_comments_count': feedbacks.reduce((acc, v) => {
                        return acc + (v.hasOwnProperty(x) ? v[x]['negative'] : 0)
                    }, 0),
                }
            }
        )
    }

    aggregateFeedbackByDate(feedbacks, step) {

        if (!feedbacks) {
            return []
        }

        step = step === 'Tous' ? 'Predominant_Sentiment_Comprehend' : step
        const process = (sent, s) => feedbacks.map(val => {
                return {
                    t: new Date(val['timestamp']),
                    y: val.hasOwnProperty(step) ? s*val[step][sent] : 0
                }
            }
        )
        return {
            'positive_comments_count': process('positive', 1),
            'negative_comments_count': process('negative', -1),
            'difference': feedbacks.map(val => {
                    return {
                        t: new Date(val['timestamp']),
                        y: val.hasOwnProperty(step) ? (val[step]['positive'] - val[step]['negative']) : 0
                    }
                }
            )
        }
    }

    aggregateSentimentsPerTimePerTopics(fetchedSentiments, step) {

        console.log(fetchedSentiments)

        const process = (sentiment, note) => fetchedSentiments.map(fetchedSentiment => {
            return {
                t: new Date(fetchedSentiment['timestamp']),
                y: Object.keys(fetchedSentiment)
                    .filter(category => {
                        const isSentiment = fetchedSentiment[category][sentiment] !== undefined
                        if (step === undefined || step === 'Tous') {
                            if (isSentiment) return category
                        } else {
                            if (isSentiment && category === step) return category
                        }
                    })
                    .map(category => {
                        return fetchedSentiment[category][sentiment]
                    }).reduce((accumulator, current) => accumulator + current, 0) * note
            }
        })

        return {
            'positive_comments_count': process('positive', 1),
            'negative_comments_count': process('negative', -1),
            'difference': fetchedSentiments.map(fetchedSentiment => {
                    return {
                        t: new Date(fetchedSentiment['timestamp']),
                        y: Object.keys(fetchedSentiment)
                            .filter(category => {
                                const isSentiment = fetchedSentiment[category]['positive'] !== undefined && fetchedSentiment[category]['negative'] !== undefined
                                if (step === undefined || step === 'Tous') {
                                    if (isSentiment) return category
                                } else {
                                    if (isSentiment && category === step) return category
                                }
                            })
                            .map(category => {
                                return fetchedSentiment[category]['positive'] || fetchedSentiment[category]['negative'] ?
                                    fetchedSentiment[category]['positive'] - fetchedSentiment[category]['negative'] : 0
                            }).reduce((accumulator, current) => accumulator + current, 0)
                    }
                }
            )
        }
    }

    listNer(feedbacks) {
        const output = {"Tous": ["Tous"], "PERSON": [], "LOCATION": [], "ORGANIZATION": [], "COMMERCIAL_ITEM": [], "EVENT": [], "DATE": [], "QUANTITY": [], "TITLE": [], "OTHER": [], "Commercial Reference: Product Name": [], "Product Group": []};

        feedbacks.map(
            x => x['Named_Entities']
        ).reduce(
            (acc, v) => acc.concat(v)
        , []).filter(
            x => x && x.hasOwnProperty('Type')
        ).forEach(
            x => {
                if (output[x['Type']]) {
                    output[x['Type']].push(x['Text'].toLowerCase())
                }
            }
        )

        for (const k in output) {
            output[k] = output[k].filter((v, i, a) => a.indexOf(v) === i);
        }

        return output
    }

    parseTopicName(text) {
        return text.split(' | ').length > 1 ? text.split(' | ')[1] : text;
    }

    fetchKpi(filters, id) {
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_kpis',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify({
                    filters: filters,
                    id: id
                })
            }
        )
            .then((response) => {
                if (!response.ok) {
                    response.text().then(console.log)
                    return {}
                }
                return response.json()
            })
            .catch((err) => {
                console.warn(err)
                return {}
            });
    }

    fetchSentimentPerTopic(filters) {
        if (filters['brand'] == undefined || filters['brand'].length < 1) {
            return new Promise(
                res => res([])
            )
        } 
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_sentiments_per_topic',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
            .then((response) => {
                if (!response.ok) {
                    response.text().then(console.log)
                    return []
                }
                return response.json()
            })
            .catch((err) => {
                console.warn(err)
                return []
            });
    }

    fetchSentimentPerTimePerTopics(filters) {
        if (filters['brand'] == undefined || filters['brand'].length < 1) {
            return new Promise(
                res => res([])
            )
        } 
        return fetch(
            process.env.REACT_APP_DASHBOARD_BACKEND_API + '/get_sentiments_per_time_per_topics',
            {
                method: "POST",
                headers: { "Authorization": this.getUrlVars()['access_token'] || localStorage.getItem('token') },
                body: JSON.stringify(filters)
            }
        )
            .then((response) => {
                if (!response.ok) {
                    response.text().then(console.log)
                    return [] 
                }
                return response.json()
            })
            .catch((err) => {
                console.warn(err)
                return []
            });
    }
}

let utils = new Utils();



export default utils;
